import { defineMessages } from 'react-intl';

export default defineMessages({
    createDraftErrorTitle: {
        id: 'wni.fnol.gl.views.incidentdetails.common.Error creating incidents',
        defaultMessage: 'Error creating incidents'
    },
    createDraftErrorMessage: {
        id: 'wni.fnol.gl.views.incidentdetails.common.An error occurred attempting to update incidents.',
        defaultMessage: 'An error occurred attempting to update incidents.'
    },
    Delete: {
        id: 'wni.fnol.gl.views.incidentdetails.common-incidents.Delete',
        defaultMessage: "Delete"
    },
    AddProperty: {
        id: 'wni.fnol.gl.views.incidentdetails.propertyIncidents.AddProperty',
        defaultMessage: "Add Property"
    },
    AddInjury: {
        id: 'wni.fnol.gl.views.incidentdetails.injuryIncidents.AddInjury',
        defaultMessage: "Add Injury"
    },
    addPerson: {
        id: 'wni.fnol.gl.views.incidentdetails.injuryIncidents.addPerson',
        defaultMessage: "-- Add Person --"
    },
    AddVehicle: {
        id: 'wni.fnol.gl.views.incidentdetails.vehicleIncidents.AddVehicle',
        defaultMessage: "Add Vehicle"
    },
    AddNewVehicle: {
        id: 'wni.fnol.gl.views.incidentdetails.vehicleIncidents.AddNewVehicle',
        defaultMessage: "-- Add Vehicle --"
    },
    AddNewProperty: {
        id: 'wni.fnol.gl.views.incidentdetails.propertyIncidents.AddNewProperty',
        defaultMessage: "-- Add Property --"
    },
    addNewPerson: {
        id: 'wni.fnol.gl.views.incidentdetails.propertyIncidents.addNewPerson',
        defaultMessage: "-- Add New Person --"
    },
    addNewCompany: {
        id: 'wni.fnol.gl.views.incidentdetails.propertyIncidents.addNewCompany',
        defaultMessage: "-- Add New Company --"
    },
    removeIncidentTitle: {
        id: 'wni.fnol.gl.views.incidentdetails.common.deleteTitle',
        defaultMessage: 'Want to Delete?',
    },
    removeIncident: {
        id: 'wni.fnol.gl.views.incidentdetails.common.Are you sure you want to delete this record?',
        defaultMessage: 'Are you sure you want to delete this record?'
    },
    cancel: {
        id: 'wni.fnol.gl.views.incidentdetails.common.cancel',
        defaultMessage: 'Cancel'
    },
    saveAndContinue: {
        id: 'wni.fnol.gl.views.incidentdetails.common.save',
        defaultMessage: 'Save & Continue'
    },
    edit: {
        id: 'wni.fnol.gl.views.gl-incident-deails.injury-incident.Edit',
        defaultMessage: 'Edit'
    },
});
